import { useLocationsContext } from '@/src/contexts/LocationsContext'

export type LocationOption = { value: number; label: string }

/**
 * Returns a flat list of location options for use in selects and popovers.
 * Index 0 is the company-level group ("Gruppe") whose id lives on `rawLocationPgId`,
 * subsequent entries are individual site locations using `locationPgId`.
 */
export const useLocationOptions = (): LocationOption[] => {
  const { locations } = useLocationsContext()

  if (!locations) return []

  return locations.map((loc, i) => {
    if (i === 0) {
      // The AllLocation union type carries rawLocationPgId only on the first element.
      const allLoc = loc as unknown as { rawLocationPgId: number }
      return { value: allLoc.rawLocationPgId, label: 'Gruppe' }
    }
    return { value: loc.locationPgId, label: loc.name }
  })
}
